'use strict';

/**
 * Floating CTAs: once the main banner of the page (hero carousel) has scrolled up above
 * the floating bar, the buttons stay fixed at the bottom of the screen until the user
 * scrolls to the component's own position, then they dock there and scroll normally.
 * Once the user scrolls past that position they stay static.
 */
$(document).ready(function () {
    var $wrappers = $('.two-cta-wrapper.js-floating-cta');

    if (!$wrappers.length) {
        return;
    }

    // main banner of the page (hero carousel), falls back to the first top-level component
    var firstComponent = $('.storepage .hero-carousel').get(0)
        || $('.storepage .experience-region').first().children('.experience-component').get(0);
    var ticking = false;

    /**
     * Toggles floating state for every floating CTA wrapper based on its position
     */
    function updateFloating() {
        var viewportHeight = window.innerHeight;

        $wrappers.each(function () {
            var $wrapper = $(this);
            var $buttons = $wrapper.find('.two-cta-buttons');
            var barHeight = $buttons.outerHeight();

            // keep the wrapper's static height so the page does not jump while the buttons are fixed
            if (!$wrapper.hasClass('is-floating')) {
                $wrapper.css('min-height', barHeight);
            }

            // do not cover the main banner: start floating only after it has scrolled above the bar
            var bannerPassed = !firstComponent || $.contains(firstComponent, this)
                || firstComponent.getBoundingClientRect().bottom <= viewportHeight - barHeight;

            // float only while the CTAs' own position is still below the visible screen
            var shouldFloat = bannerPassed && this.getBoundingClientRect().bottom > viewportHeight;
            $wrapper.toggleClass('is-floating', shouldFloat);
        });

        ticking = false;
    }

    $(window).on('scroll resize', function () {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(updateFloating);
        }
    });

    updateFloating();
});
